import { FormControl, TextField } from '@mui/material';
import React from 'react';
import { SubscriptionStatus } from '../../interfaces/Hoster';
import { HosterDto } from '../../reduxtk/hoster';

interface HosterProps {
  hoster: Partial<HosterDto>;
  updateSubscribedLanguagesNumber: (number: number) => void;
}

const HosterLanguageSubscription: React.FC<HosterProps> = ({
  hoster,
  updateSubscribedLanguagesNumber,
}) => {
  const initialValue =
    (hoster.subscriptionStatus as SubscriptionStatus)?.subscribedLanguageNumber ?? 0;
  const [languagesNumber, setLanguagesNumber] = React.useState<number>(initialValue);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const value = parseInt(event.target.value, 10);
    if (!isNaN(value) && value >= 0) {
      setLanguagesNumber(value);
      updateSubscribedLanguagesNumber(value);
    }
  };

  return (
    <div>
      <FormControl sx={{ m: 1, width: 300 }}>
        <TextField
          id="subscribed-languages-number"
          label="Nombre de langues souscrites"
          type="number"
          value={languagesNumber}
          onChange={handleChange}
          inputProps={{ min: 0 }}
        />
      </FormControl>
    </div>
  );
};

export default HosterLanguageSubscription;
